import { useState, useEffect } from 'react'
import { getConteudoChave, putConteudoChave } from '@/api/adminApi'
import { ADMIN_KEYS, CONTEUDO_API_KEYS } from '@/utils/adminStorage'
import { useSaveFeedback } from '@/hooks/useSaveFeedback'
import styles from './Admin.module.css'

export function AdminMapaPage() {
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { notifySaved, notifyError } = useSaveFeedback()
  const apiChave = CONTEUDO_API_KEYS[ADMIN_KEYS.mapa]

  useEffect(() => {
    let cancelled = false
    setError(null)
    getConteudoChave(apiChave)
      .then((v) => { if (!cancelled) setUrl(v ?? '') })
      .catch((e) => { if (!cancelled) setError(e instanceof Error ? e.message : 'Erro ao carregar') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [apiChave])

  const handleSalvar = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    try {
      await putConteudoChave(apiChave, url.trim() || null)
      notifySaved('Mapa guardado.')
    } catch (e) {
      notifyError(e, 'Erro ao salvar')
      setError(e instanceof Error ? e.message : 'Erro ao salvar')
    } finally {
      setSaving(false)
    }
  }

  const isEmbed = /embed|pb=/.test(url.trim())
  const embedSrc = isEmbed ? url.trim() : url.trim().replace(/\/view.*$/, '').replace(/\/@.*$/, '') + '/embed'

  if (loading) return <p className={styles.placeholderMsg}>A carregar…</p>

  return (
    <div className={styles.pageMapa}>
      <header className={styles.sectionHeader}>
        <h1 className={styles.sectionTitle}>Mapa</h1>
        <p className={styles.sectionSubtitle}>
          Cole o link do Google Maps (partilhar → Incorporar mapa) ou o URL da localização. Em baixo aparece uma pré-visualização.
        </p>
      </header>
      {error && (
        <div className={styles.erroSection}>
          <p className={styles.erro}>{error}</p>
        </div>
      )}
      <div className={styles.mapaCard}>
        <form onSubmit={handleSalvar}>
          <div className={styles.formGroup}>
            <label>URL do mapa</label>
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://www.google.com/maps/embed?..."
            />
          </div>
          <div className={styles.mapaRow}>
            <div className={styles.mapaPreview}>
              {url.trim() ? (
                <iframe
                  title="Preview do mapa"
                  src={embedSrc}
                />
              ) : (
                'Pré-visualização do mapa aparecerá aqui após colar o URL'
              )}
            </div>
          </div>
          <button type="submit" className={styles.btnSalvar} disabled={saving} style={{ marginTop: 16 }}>
            {saving ? 'A guardar…' : 'Guardar URL'}
          </button>
        </form>
      </div>
    </div>
  )
}
